import React from 'react';
import { Line } from 'react-chartjs-2';

import { COLOR_FONT_1, COLOR_SURFACE_1_RELIEF } from '../../colors';

/**
 *
 */
export function LineChart(props) {
  const options = {
    legend: {
      display: false
    },
    responsive: true,
    maintainAspectRatios: false,
    scales: {
      xAxes: [
        {
          gridLines: {
            display: false,
            color: COLOR_SURFACE_1_RELIEF
          },
          ticks: {
            display: false,
            color: COLOR_FONT_1,
            autoSkip: false
          }
        }
      ],
      yAxes: [
        {
          gridLines: {
            color: COLOR_SURFACE_1_RELIEF
          },
          ticks: {
            fontColor: COLOR_FONT_1,
            maxTicksLimit: 8,
            min: 0,
            stepSize: 0,
            callback: (value) => value.toLocaleString().replace(',000', 'K')
          }
        }
      ]
    },
    tooltips: {
      callbacks: {
        label: (item) => item.yLabel.toLocaleString()
      }
    }
  };

  return <Line data={props.data} options={options} redraw={false} />;
}
